import styles from "css/buttons/BidButton.module.css";
import ButtonWithText from "components/buttons/ButtonWithText";
import ButtonTheme from "types/enums/ButtonTheme";
import FontClass from "types/enums/FontClass";
import { useState } from "react";
import BidModal from "components/modal/BidModal";
import graphql from "babel-plugin-relay/macro";
import { BidButton_MetadataAccount$key } from "components/buttons/__generated__/BidButton_MetadataAccount.graphql";
import { useFragment } from "react-relay";

const fragment = graphql`
  fragment BidButton_MetadataAccount on MetadataAccount {
    id
    ...BidModal_MetadataAccount
  }
`;

type Props = {
  metadataAccount: BidButton_MetadataAccount$key;
};

export default function BidButton({ metadataAccount }: Props): JSX.Element {
  const [isShown, setIsShown] = useState(false);
  const metadataAccountData = useFragment(fragment, metadataAccount);

  return (
    <>
      <BidModal
        isShown={isShown}
        metadataAccount={metadataAccountData}
        onHide={() => setIsShown(false)}
      />
      <ButtonWithText
        buttonTheme={ButtonTheme.PurpleGradient}
        className={styles.button}
        fontClass={FontClass.NavLink}
        onClick={() => setIsShown(true)}
      >
        Place a bid
      </ButtonWithText>
    </>
  );
}
